import { render } from "./SystemSettingsHeader.vue?vue&type=template&id=4e87b8fb&scoped=true"
import script from "./SystemSettingsHeader.vue?vue&type=script&lang=js"
export * from "./SystemSettingsHeader.vue?vue&type=script&lang=js"

import "./SystemSettingsHeader.vue?vue&type=style&index=0&id=4e87b8fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e87b8fb"]])

export default __exports__